import type { HttpPost } from '@/shared/infra/http'
import type {
  ExchangeTransferCode,
  ExchangeTransferCodeParams,
} from '@/modules/auth/use-cases'

type ExchangeTransferCodeApiResponse = {
  access_token: string
  refresh_token: string
}

export class EdgeExchangeTransferCodeRepository {
  constructor(private readonly httpClient: HttpPost) {}

  execute: ExchangeTransferCode = async (params) => {
    const response = await this.httpClient.post<
      ExchangeTransferCodeParams,
      ExchangeTransferCodeApiResponse
    >({
      url: '/auth-transfer-codes/exchange',
      body: { code: params.code },
    })
    return {
      accessToken: response.access_token,
      refreshToken: response.refresh_token,
    }
  }
}
